// extracted by mini-css-extract-plugin
export default {"paginationContainer":"styles_paginationContainer__P+7t3","page":"styles_page__j+Lwl","active_page":"styles_active_page__47sPN"};